import BaseService from './_base.service';

export const creditService = {
    page,
    search,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/credits/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/credits/page/"+page+"/"+size,filter, callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/credits/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/credits/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/credits/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/credits/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/credits/"+id+"/logic", callback);
}
